import * as angular from "angular";

angular
  .module('bringoz.admin.auctions', ['md.data.table']);
